export interface PointersProps {
    leftLength?: number
    rightLength?: number
}

export const compactString = (value: string, pointers?: PointersProps) => {
    let { leftLength = 6, rightLength = 6 } = pointers || {}

    if (Math.abs(leftLength) + Math.abs(rightLength) > value.length - 1) {
        return value
    }

    leftLength = Math.abs(leftLength)
    rightLength = rightLength === 0 ? value.length : -Math.abs(rightLength)

    return value.slice(0, leftLength) + '...' + value.slice(rightLength)
}
